import styled from "styled-components";
import media from "styled-media-query";

import bg from '../../assets/bg-fortnite.jpg'

export const SectionExtra = styled.section`
  &::before {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.7);
    z-index: -1;
  }
  background-image: url(${bg});
  background-size: cover;
  background-position: center center;
  position: relative;
  padding: 65px 24px 210px;
  z-index: 2;

  ${media.lessThan('1024px')`
    padding: 40px 6px 65px;
  `}
  
.container {
  margin: 0 auto;
  max-width: 1366px;
  z-index: 3;
  ${media.lessThan('1366px')`
    max-width: 980px;
  `}

  ${media.between('1024px', '1366px')`
    button {
      max-width: 383px;
      height: 56px;
      font-size: 16px;
    }
  `}

  ${media.lessThan('1024px')`
    max-width: 780px;
  `}

  .card-extra {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    border-radius: 50px;

    ${media.lessThan('1366px')`
      border-radius: 30px;
    `}


    ${media.lessThan('1024px')`
      border-radius: 20px;
      justify-content: center;
    `}

    .info {
      ${media.lessThan('1024px')`
        display: flex;
        flex-direction: column;
        align-items: center;
      `}

      h2 {
        font-size: 38px;
        font-weight: 900;
        ${media.lessThan('1366px')`
          font-size: 30px;
          line-height: 39px;
        `}
        ${media.lessThan('1024px')`
          font-size: 23px;
          align-self: flex-start;
          line-height: 29px;
        `}
      }
      p {
        color: #FFFFFF;
        font-size: 25px;
        ${media.lessThan('1366px')`
          font-size: 19px;
        `}
        ${media.lessThan('1024px')`
          font-size: 18px;
        `}
      }
    }
  }

  .enem-action {
    margin-bottom: 90px;
    background-color: #593E8B;
    padding: 110px 47px 90px 83px;

    ${media.lessThan('1366px')`
      margin-bottom: 70px;
      padding: 70px 37px 60px 60px;
    `}
    
    ${media.lessThan('1024px')`
      padding: 55px 34px 47px 35px;
      margin-bottom: 43px;
    `}

    .info {
      h2 {
        color: #FFDC07;
        width: 100%;
        max-width: 769px;
        font-style: normal;
        font-weight: 900;
        font-size: 40px;
        line-height: 49px;
        ${media.lessThan('1366px')`
          font-size: 30px;
          line-height: 39px;
        `}

        ${media.lessThan('1024px')`
          font-size: 24px;
          line-height: 29px;
        `}
      }

      p {
        width: 100%;
        max-width: 728px;
        margin: 40px 42px 40px 0;
        ${media.lessThan('1024px')`
          margin: 14px 0 43px;
        `}
      }
    }

    img {
      max-width: 415px;
      max-height: 378px;
      width: 100%;
      height: 100%;
      ${media.lessThan('1024px')`
        display: none;
      `}
      ${media.lessThan('1366px')`
        max-width: 300px;
      `}
    }
  }

  .experimente-seu-brilho {
    background-color: #129BC5;
    padding: 13px 78px 12px 70px;

    ${media.lessThan('1366px')`
      padding: 13px 38px 6px 50px;
      img {
        max-width: 300px;
      }
    `}
    
    ${media.lessThan('1024px')`
      height: 100%;
      padding: 52px 34px 45px;
      img {
        display: none;
      }
    `}

    .info {
      h2 {
        color: #FFFFFF;
        align-self: flex-start;
      }

      p {
        width: 100%;
        max-width: 640px;
        margin: 33px 0 40px;
      }
    }
  }
  
}
`;
